import { LAYOUT } from '@admin/router/constant'

// plm基础配置
const plmBasicConfigurationRouter = {
  path: '/plmBasicConfiguration',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/plm-basic-configuration/unit',
      name: 'Unit',
      component: () => import('@admin/views/plm/plmBasicConfiguration/unit/index.vue'),
      meta: { helpUrl: '', title: '单位' },
    },
    {
      path: '/plm-basic-configuration/color-configuration',
      name: 'plmBasicConfiguration',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/colorConfiguration/index.vue'),
      meta: { helpUrl: '', title: '深衣颜色' },
    },
    {
      path: '/plm-basic-configuration/sizing-information',
      name: 'sizingInformation',
      component: () => import('@admin/views/plm/plmBasicConfiguration/sizingInformation/index.vue'),
      meta: { helpUrl: '', title: '尺码信息' },
    },
    {
      path: '/plm-basic-configuration/commodity-design-attribute',
      name: 'commodityDesignAttribute',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/commodityDesignAttribute/index.vue'),
      meta: { helpUrl: '', title: '商品设计属性' },
    },
    {
      path: '/plm-basic-configuration/product-processing-technology',
      name: 'productProcessingTechnology',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/productProcessingTechnology/index.vue'),
      meta: { helpUrl: '', title: '特殊二次工艺' },
    },
    {
      path: '/plm-basic-configuration/material-processing-technology',
      name: 'materialProcessingTechnology',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/materialProcessingTechnology/index.vue'),
      meta: { helpUrl: '', title: '物料加工工艺' },
    },
    {
      path: '/plm-basic-configuration/part-type',
      name: 'partType',
      component: () => import('@admin/views/plm/plmBasicConfiguration/partType/index.vue'),
      meta: { helpUrl: '', title: '部位类型' },
    },
    {
      path: '/plm-basic-configuration/flower-pattern-library',
      name: 'flowerPatternLibrary',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/flowerPatternLibrary/index.vue'),
      meta: { helpUrl: '', title: '花型库' },
    },
    {
      path: '/plm-basic-configuration/measurement-file',
      name: 'measurementFile',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/measurementFile/index/index.vue'),
      meta: { helpUrl: '', title: '度量档案' },
    },
    {
      path: '/plm-basic-configuration/measurement-file-detail',
      name: 'measurementFileDetail',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/measurementFile/detail/index.vue'),
      meta: { helpUrl: '', title: '度量档案详情' },
    },
    {
      path: '/plm-basic-configuration/pricing-process-library',
      name: 'pricingProcessLibrary',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/pricingProcessLibrary/index.vue'),
      meta: { helpUrl: '', title: '核价工序库' },
    },
    {
      path: '/plm-basic-configuration/measurement-sites',
      name: 'measurementSites',
      component: () => import('@admin/views/plm/plmBasicConfiguration/measurementSites/index.vue'),
      meta: { helpUrl: '', title: '度量部位' },
    },
    {
      path: '/plm-basic-configuration/process-archives',
      name: 'processArchives',
      component: () => import('@admin/views/plm/plmBasicConfiguration/processArchives/index.vue'),
      meta: { helpUrl: '', title: '工艺档案' },
    },
    {
      path: '/plm-basic-configuration/development-classification-issues',
      name: 'developmentClassificationIssues',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/developmentClassificationIssues/index.vue'),
      meta: { helpUrl: '', title: '开发问题分类' },
    },
    {
      path: '/plm-basic-configuration/commodity-production-cycle',
      name: 'commodityProductionCycle',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/commodityProductionCycle/index.vue'),
      meta: {
        helpUrl: '',
        title: '商品生产周期配置',
      },
    },
    {
      path: '/plm-basic-configuration/process-difficulty-level',
      name: 'processDifficultyLevel',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/processDifficultyLevel/index.vue'),
      meta: {
        helpUrl: '',
        title: '加工生产难度等级配置',
        helpMessageUrl: 'SPU核价单的加工工价合计（不包含倍率）',
      },
    },
    {
      path: '/plm-basic-configuration/secondary-process-level',
      name: 'secondaryProcessLevel',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/secondaryProcessLevel/index.vue'),
      meta: { helpUrl: '', title: '二次工艺生产难度等级配置' },
    },
    {
      path: '/plm-basic-configuration/production-difficulty-level',
      name: 'productionDifficultyLevel',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/productionDifficultyLevel/index.vue'),
      meta: { helpUrl: '', title: '生产难度等级配置' },
    },
    {
      path: '/plm-basic-configuration/measurement-tolerance-library',
      name: 'measurementToleranceLibrary',
      component: () =>
        import('@admin/views/plm/plmBasicConfiguration/measurementToleranceLibrary/index.vue'),
      meta: { helpUrl: '', title: '度量档差库' },
    },
  ],
}

export default plmBasicConfigurationRouter
